export const enUS_dashboard = {
  'app.dashboard.overview.totalSales': 'Total Sales',
  'app.dashboard.overview.visits': 'Visits',
  'app.dashboard.overview.payments': 'Payments',
  'app.dashboard.overview.operationalEffect': 'Operational Effect',
  'app.dashboard.overview.wowChange': 'WoW Change',
  'app.dashboard.overview.dodChange': 'DoD Change',
  'app.dashboard.overview.dailySales': 'Daily Sales',
  'app.dashboard.overview.visits.dailyVisits': 'Daily Visits',
  'app.dashboard.overview.conversionRate': 'Conversion Rate',
  'app.dashboard.salePercent.proportionOfSales': 'The Proportion Of Sales',
  'app.dashboard.salePercent.all': 'All',
  'app.dashboard.salePercent.online': 'Online',
  'app.dashboard.salePercent.offline': 'Offline',
  'app.dashboard.timeline.traffic': 'Traffic',
  'app.dashboard.timeline.payments': 'Payments',
};
